import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OCRCompanyContainerModel } from "../../../../../models";
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { Core2Config } from '../shared/core2Config';

// https://api.akaun.dev/core2/platform/dm/tenants/tenant-users

@Injectable({
  providedIn: 'root'
})

export class OCRCompanyService extends BaseApiPublicLoginTemplateService<OCRCompanyContainerModel, OCRCompanyContainerModel, OCRCompanyContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/companies/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/companies/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/companies/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/companies/' + BaseApiPublicLoginTemplateService.LOGIN_EP;
    this.httpClient = http;
  }
}

